/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerSurveysResponseService = {
  async saveCustomerSurveyResponse(payload) {
    var url = "api/Save_SurveyResponse";

    return await ApiService.post(url, payload, "String");
  },

  async getBySurveyResponse(code) {
    const requestScreenData = {
      url: "api/SurveyResponse",
      filter: `RecordId eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getCustomerSurveyTemplateByRecordId(code, CustomerCode) {
    const requestScreenData = {
      url: "api/CustomerSurveyTemplate",
      filter: `SurveyTemplateRecordID eq ${code} and CustomerCode eq '${CustomerCode}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getSurveyResponseQuestion(code) {
    const requestScreenData = {
      url: "api/SurveyResponseQuestion",
      filter: `SurveyResponseRecordID eq ${code}`,
      orderby: "Sequence asc",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getSurveyResponseQuestionImagesMeta(code) {
    const requestScreenData = {
      url: "api/SurveyResponseQuestionImagesMeta",
      filter: `SurveyResponseQuestionRecordID eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getSurveyResponseQuestionNote(code) {
    const requestScreenData = {
      url: "api/SurveyResponseQuestionNote",
      filter: `SurveyResponseQuestionRecordID eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  // async getCallLogNoteImagesMetaByCallLogNote(code) {
  //   const requestScreenData = {
  //     url: "api/CallLogNoteImagesMeta",
  //     filter: `CallLogNoteRecordID eq ${code}`,// and SizeType eq 'thumb'`,
  //   };

  //   return await ApiService.oDataGet(requestScreenData);
  // },
  async getActiveSurveysForCustomer(code) {
    var date = new Date().toFilterDateStartTime();
    const requestScreenData = {
      url: "api/SurveyResponseList",
      filter: `(FriendlyStatus eq 'Active' or FriendlyStatus eq 'Pending') and CustomerCode eq '${code}' and SurveyTemplateStartDate le ${new Date(date).getStartDateWithUTC()}`,
      select: ["CustomerCode", "SurveyTemplateRecordId", "RecordId", "FriendlyStatus", "SurveyTemplateStartDate"],
      top: 1
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { CustomerSurveysResponseService };
